import { createSlice } from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loader",
  initialState: {
    showLoader: true,
  },
  reducers: {
    closeHandler(state) {
      state.showLoader = false;
    },
    openHandler(state) {
      state.showLoader = true;
    },
  },
});

export const loadingActions = loadingSlice.actions;
export default loadingSlice;
